const KEY = {
	ENTER: 13,
	BACKSPACE: 8,
	ESC: 27,
	UP: 38,
	DOWN: 40,
	TAB: 9,
	COMMA: 188,
};

var KeyboardUtils = {
	KEY: KEY,

	isEnterKey: function(event) {
		var nodeName;
		var key;

		if (!event) return;

		nodeName = event.target.nodeName;
		key = event.keyCode;

		return key === KEY.ENTER && nodeName !== 'TEXTAREA' && nodeName !== 'BUTTON';
	},

	isEscapeKey: function(e) {
		return e.keyCode === this.KEY.ESC;
	},

	isTabKey: function(e) {
		return e && e.keyCode === this.KEY.TAB;
	},

	isCommandEnter: function(e) {
		return e.metaKey && e.keyCode == KEY.ENTER;
	},

	isCommaOrEnterKey: function(e) {
		return e && (e.keyCode === KEY.COMMA || e.keyCode === KEY.ENTER);
	},
};

module.exports = KeyboardUtils;
